const socketActions = {
  SOCKET_TIMEOUT: "SOCKET_TIMEOUT",
  SOCKET_GOT_CONNECTION: "SOCKET_GOT_CONNECTION",
  SOCKET_LOST_CONNECTION: "SOCKET_LOST_CONNECTION",
  TOUCH: "TOUCH",
};

export default socketActions;
